export enum ComposeEmailOrigin {
  Default = 0,
  FolioRequestSection = 1
}
